let msnry;
let showcaseData = {};
let currentPage = 1;
let totalPages = 1;

async function loadShowcases(page = 1) {
  try {
    const response = await fetch(`https://apps.gemstonesforsale.com/wp-json/gemstone-sale/v1/get-showcases?page=${page}`);
    const data = await response.json();
    const btn = document.getElementById('showMoreBtn');
    btn.style.display = 'none';
    currentPage = data.pagination.current_page;
    totalPages = data.pagination.total_pages;

    const grid = document.getElementById('showcase-masonry-grid');
    const newItems = [];

    Object.entries(data.showcase).forEach(([id, showcase]) => {
      if (!showcaseData[id]) {
        showcaseData[id] = showcase;

        const el = createShowcaseElement(showcase, id);
        el.classList.add('grid-item');
        grid.appendChild(el);
        newItems.push(el);
      }
    });

    // Wait for images to load
      imagesLoaded(grid, () => {
        // Wait for all videos to finish loading metadata
        const videos = grid.querySelectorAll('video');
        const videoPromises = Array.from(videos).map(video => {
          return new Promise(resolve => {
            if (video.readyState >= 1) {
              // Already loaded metadata
              resolve();
            } else {
              video.addEventListener('loadedmetadata', resolve, { once: true });
            }
          });
        });
      
        Promise.all(videoPromises).then(() => {
          // Now initialize or update Masonry
          if (!msnry) {
            msnry = new Masonry(grid, {
              itemSelector: '.grid-item',
              columnWidth: '.grid-sizer',
              percentPosition: true,
              gutter: 24 // handled in CSS padding
            });
          } else {
            msnry.appended(newItems);
            msnry.layout();
          }
        });
      });

    //
    btn.style.display = 'inline-block';
    toggleShowMoreButton();
    initializeSliders();
  } catch (err) {
    console.error('Error loading showcases:', err);
  }
}

function toggleShowMoreButton() {
  const btn = document.getElementById('showMoreBtn');
  if (currentPage >= totalPages) {
    btn.style.display = 'none';
  } else {
    btn.style.display = 'inline-block';
  }
}

// Create individual showcase element
function createShowcaseElement(showcase, id) {
  const div = document.createElement('div');
  div.className = 'single-showcase';
  div.setAttribute('data-showcase-id', id);

  div.innerHTML = `
    <div class="single-showcase-media">
      ${createImageSlider(showcase.gallery, id)}
    </div>
    <div class="single-showcase-meta" data-showcase-id="${id}">
      <div class="single-showcase-author">
        <span class="author_name">${showcase.name}</span>
      </div>
      <div class="showcase-creation-story">${showcase.creation_story}</div>
    </div>
  `;

  return div;
}

// Create image slider for gallery images
function createImageSlider(gallery, showcaseId) {
  if (!gallery || gallery.length === 0) {
    return '<div class="slider-placeholder">No media available</div>';
  }

  let sliderHTML = '<div class="image-slider">';

  if (gallery.length > 1) {
    sliderHTML += '<div class="slider-container">';
    gallery.forEach(([type, url], index) => {
      sliderHTML += `
        <div class="slide ${index === 0 ? 'active' : ''}" data-slide="${index}">
          ${type === 'video'
            ? `<video controls class="showcase-video" data-showcase-id="${showcaseId}" preload="metadata" autoplay muted loop>
                 <source src="${url}" type="video/mp4">
               </video>`
            : `<img src="${url}" alt="Jewelry showcase" class="showcase-image" data-showcase-id="${showcaseId}">`}
        </div>
      `;
    });
    sliderHTML += '</div>';

    // Add navigation dots
    sliderHTML += '<div class="slider-dots">';
    gallery.forEach((_, index) => {
      sliderHTML += `<span class="dot ${index === 0 ? 'active' : ''}" data-slide="${index}"></span>`;
    });
    sliderHTML += '</div>';
  } else {
    const [type, url] = gallery[0];
    sliderHTML += type === 'video'
      ? `<video controls class="showcase-video" data-showcase-id="${showcaseId}" preload="metadata" autoplay muted loop>
           <source src="${url}" type="video/mp4">
         </video>`
      : `<img src="${url}" alt="Jewelry showcase" class="showcase-image" data-showcase-id="${showcaseId}">`;
  }

  sliderHTML += '</div>';
  return sliderHTML;
}

// Modal functionality
function openModal(showcaseId) {
  const showcase = showcaseData[showcaseId];
  if (!showcase) return;

  const modal = document.getElementById('showcaseModal');

  // Populate modal content
  document.getElementById('modalAuthorName').textContent = showcase.name;
  document.getElementById('modalCreated').textContent = showcase.created;
  document.getElementById('modalJewelryType').textContent = showcase.jewelry_type;
  document.getElementById('modalGemstone').textContent = showcase.gemstone_used;
  document.getElementById('modalCreation').textContent = showcase.creation;
  document.getElementById('modalCreationStory').textContent = showcase.creation_story;

  // Create modal media slider
  const modalImageSlider = document.getElementById('modalImageSlider');
  modalImageSlider.innerHTML = createModalImageSlider(showcase.gallery, showcaseId);

  // Show modal
  modal.classList.add('active');
  document.body.style.overflow = 'hidden';

  // Initialize modal slider
  initializeModalSlider();
}

function closeModal() {
  const modal = document.getElementById('showcaseModal');
  modal.classList.remove('active');
  document.body.style.overflow = 'auto';
}

function createModalImageSlider(gallery, showcaseId) {
  if (!gallery || gallery.length === 0) {
    return '<div class="modal-no-images">No media available</div>';
  }

  let sliderHTML = '<div class="modal-slider-container">';

  gallery.forEach(([type, url], index) => {
    sliderHTML += `
      <div class="modal-slide ${index === 0 ? 'active' : ''}" data-slide="${index}">
        ${type === 'video'
          ? `<video controls class="modal-video" data-showcase-id="${showcaseId}" preload="metadata">
               <source src="${url}" type="video/mp4">
             </video>`
          : `<img src="${url}" alt="Jewelry showcase" loading="lazy" class="modal-image" data-showcase-id="${showcaseId}">`}
      </div>
    `;
  });

  sliderHTML += '</div>';

  if (gallery.length > 1) {
    sliderHTML += `
      <div class="modal-slider-nav">
        <button class="modal-nav-btn prev" id="modalPrevBtn">‹</button>
        <button class="modal-nav-btn next" id="modalNextBtn">›</button>
      </div>
      <div class="modal-slider-dots">
        ${gallery.map((_, index) => `<span class="modal-dot ${index === 0 ? 'active' : ''}" data-slide="${index}"></span>`).join('')}
      </div>
    `;
  }

  return sliderHTML;
}

function initializeModalSlider() {
  const slides = document.querySelectorAll('.modal-slide');
  const dots = document.querySelectorAll('.modal-dot');
  const prevBtn = document.getElementById('modalPrevBtn');
  const nextBtn = document.getElementById('modalNextBtn');
  
  let currentSlide = 0;
  
  function showSlide(index) {
    slides.forEach(slide => slide.classList.remove('active'));
    dots.forEach(dot => dot.classList.remove('active'));
    
    if (slides[index]) {
      slides[index].classList.add('active');
      if (dots[index]) dots[index].classList.add('active');
      currentSlide = index;
    }
  }
  
  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      const newIndex = currentSlide > 0 ? currentSlide - 1 : slides.length - 1;
      showSlide(newIndex);
    });
  }
  
  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      const newIndex = currentSlide < slides.length - 1 ? currentSlide + 1 : 0;
      showSlide(newIndex);
    });
  }
  
  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => showSlide(index));
  });
}

// Get number of columns based on screen width
function getColumnCount() {
  const width = window.innerWidth;
  if (width >= 1200) return 4;
  if (width >= 768) return 3;
  if (width >= 480) return 2;
  return 1;
}

// Initialize slider functionality
function initializeSliders() {
  document.addEventListener('click', function(e) {
    // Find the closest parent with class 'single-showcase-meta'
    const showcaseMeta = e.target.closest('.single-showcase-meta');
    if (showcaseMeta) {
      const showcaseId = showcaseMeta.getAttribute('data-showcase-id');
      console.log(showcaseId);
      openModal(showcaseId);
    }
    
    // Handle slider dots
    if (e.target.classList.contains('dot')) {
      const slideIndex = parseInt(e.target.dataset.slide);
      const slider = e.target.closest('.image-slider');
      const slides = slider.querySelectorAll('.slide');
      const dots = slider.querySelectorAll('.dot');
      
      // Remove active class from all slides and dots
      slides.forEach(slide => slide.classList.remove('active'));
      dots.forEach(dot => dot.classList.remove('active'));
      
      // Add active class to selected slide and dot
      slides[slideIndex].classList.add('active');
      e.target.classList.add('active');
    }
    
    // Handle modal close
    if (e.target.id === 'modalClose' || e.target.classList.contains('modal-overlay')) {
     /* console.log(e.target);
      console.log(e.currentTarget);
      if (e.target === e.currentTarget) {*/
        closeModal();
     // }
    }
  });
}

// Handle escape key for modal
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    closeModal();
  }
});

// Load showcases when page loads
document.addEventListener('DOMContentLoaded', () => {
  loadShowcases(); // load first page

  document.getElementById('showMoreBtn').addEventListener('click', () => {
    if (currentPage < totalPages) {
      loadShowcases(currentPage + 1);
       // Wait for height change before relayout
      // Wait for images to load
      const isMobile = window.innerWidth <= 600; // or use matchMedia
      if (!isMobile) {
        setTimeout(() => {
          if (msnry) msnry.layout();
        }, 100);
      }
    }
  });

  // Responsive layout on resize
  window.addEventListener('resize', () => {
    // Wait for images to load
    const isMobile = window.innerWidth <= 600; // or use matchMedia
    if (!isMobile) {
      if (msnry) msnry.layout();
    }
  });

  initializeSliders(); // if needed
});